import { useAuth } from "@/hooks/useAuth";
import { usePaywallModal } from "@/contexts/PaywallModalContext";
import { AlertTriangle } from "lucide-react";

export function GracePeriodBanner() {
  const { profile } = useAuth();
  const { openPaywall } = usePaywallModal();
  const validUntil = profile?.subscription_valid_until;
  const isGrace = profile?.subscription_status?.toLowerCase() === "grace";
  if (!isGrace || !validUntil) return null;

  const end = new Date(validUntil);
  const now = new Date();
  const daysLeft = Math.max(0, Math.ceil((end.getTime() - now.getTime()) / (24 * 60 * 60 * 1000)));

  return (
    <div data-testid="failed-payment-banner" className="rounded-lg border border-amber-500/50 bg-amber-500/10 px-4 py-3 flex items-center justify-between gap-4 flex-wrap">
      <div className="flex items-center gap-2">
        <AlertTriangle className="h-5 w-5 text-amber-600 shrink-0" />
        <p className="text-sm font-medium text-foreground">
          Your payment didn&apos;t go through. Your Pro access continues for <strong data-testid="grace-period-days-remaining">{daysLeft} days</strong>. Update payment →
        </p>
      </div>
      <button
        data-testid="update-payment-link"
        type="button"
        onClick={() => openPaywall("upgrade_cta")}
        className="text-sm font-semibold text-amber-700 dark:text-amber-400 hover:underline shrink-0"
      >
        Update payment
      </button>
    </div>
  );
}
